import { useEffect } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router';
import { useService } from '@aesop-fables/containr-react';
import { DrillDownWizard, drillDownWizardKey } from '../services/drillDown';

export function useRedirectHomeOnBack() {
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const location = useLocation();
  const drillDownWizard = useService<DrillDownWizard>(drillDownWizardKey);

  useEffect(() => {
    const homeRoute = drillDownWizard.peekNavigatedHome();
    if (!homeRoute) {
      return;
    }

    if (navigationType === 'POP') {
      drillDownWizard.consumeNavigatedHome();
      navigate(homeRoute, { replace: true });
      return;
    }

    if (location.pathname !== homeRoute) {
      drillDownWizard.consumeNavigatedHome();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);
}
